import {
    BoxType,
    SurveyScope,
    SurveySlug,
    SpecialOptionKey,
    Question,
    SpecialOption,
    Widget
} from 'client/common/types';

import cfg from 'client/common/utils/client-config';

const SCOPE_ENDPOINTS = {
    [SurveyScope.External]: 'https://odna.co/poll',
    [SurveyScope.YandexNet]: 'https://pythia.yandex.net/poll',
    [SurveyScope.YandexTeam]: 'https://pythia.yandex-team.ru/poll',
    [SurveyScope.Yandex]: undefined
};

export const SPECIAL_OPTIONS: SpecialOptionKey[] = [
    'otherAnswer',
    'otherAnswerWithText',
    'noAnswer',
    'noOpinionAnswer'
];

export function mapSpecialOptions<T>(
    question: Question | Widget,
    fn: (question: Question, key: SpecialOptionKey, option: SpecialOption) => T
): T[] {
    const result: T[] = [];

    if ('otherAnswer' in question) result.push(fn(question, 'otherAnswer', question.otherAnswer));
    if ('otherAnswerWithText' in question)
        result.push(fn(question, 'otherAnswerWithText', question.otherAnswerWithText));
    if ('noAnswer' in question) result.push(fn(question, 'noAnswer', question.noAnswer));
    if ('noOpinionAnswer' in question)
        result.push(fn(question, 'noOpinionAnswer', question.noOpinionAnswer));

    return result;
}

export function genShareLink(
    slug: SurveySlug,
    respReuse: boolean,
    scope: SurveyScope = SurveyScope.Yandex,
    boxName?: BoxType
): string {
    let endpoint = SCOPE_ENDPOINTS[scope] || cfg.surveyEndpoint;

    if (boxName === 'ux') {
        endpoint += '/ux';
    }

    return respReuse ? `${endpoint}/enter/${slug}` : `${endpoint}/${slug}`;
}
